import { render, staticRenderFns } from "./StockListProductCategories.vue?vue&type=template&id=68b55971"
import script from "./StockListProductCategories.vue?vue&type=script&lang=js"
export * from "./StockListProductCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports